module.exports = __webpack_public_path__ + "static/img/93-3.5f1a6d3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/93-3.jpg
// module id = KS7P
// module chunks = 0